import { CubeTextureLoader } from 'three'

export function loadEnvironmentMap(basePath = '') {
    const loader = new CubeTextureLoader()
    return loader.load([
        `${basePath}/textures/environmentMaps/0/px.png`,
        `${basePath}/textures/environmentMaps/0/nx.png`,
        `${basePath}/textures/environmentMaps/0/py.png`,
        `${basePath}/textures/environmentMaps/0/ny.png`,
        `${basePath}/textures/environmentMaps/0/pz.png`,
        `${basePath}/textures/environmentMaps/0/nz.png`,
    ])
}
